import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class DataManagementJobService {
  baseUrl = 'data-management-job';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  getDocumentCount = (searchCriteria) => BaseService.get({ url: `${this.baseUrl}/get-document-count?searchCriteria=${searchCriteria}` });
  downloadExported = (id) => Utils.file.attachment.download(`${this.baseUrl}/download-exported/${id}`);
  save = (document) => BaseService.post({ url: `${this.baseUrl}/save`, data: document });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
}

export default new DataManagementJobService();
